export const FOLLOW_ITEM_TYPE = {
  IDENTITY: "identity",
  IDENTITY_ITEM: "identity_item",
  TEAM: "team",
} as const;
